// This file is auto-generated by @hey-api/openapi-ts

export type Asset = {
    comment: string | null;
    date: Date;
    asset_type: AssetType;
    object: ObjectInDB;
    id: number;
    children: Array<AssetInDB>;
};

export type AssetInDB = {
    comment: string | null;
    date: Date;
    asset_type: AssetType;
    object: ObjectInDB;
    id: number;
};

export type AssetType = {
    id: number;
    name: string;
};

export type AudioMetadata = {
    type?: 'audio';
    duration: number;
};

export type type = 'audio';

export type Body_login_access_token_api_v1_login_token_post = {
    grant_type?: string | null;
    username: string;
    password: string;
    scope?: string;
    client_id?: string | null;
    client_secret?: string | null;
};

export type Body_update_user_self_api_v1_login_self_patch = {
    name?: string;
    password?: string;
    email?: string;
};

export type Category = {
    id: number;
    name: MultiLanguage;
};

export type CategoryInDBBase = {
    id: number;
};

export type Coordinates = {
    x: number;
    y: number;
    z: number | null;
};

export type FieldTypes = 'name' | 'id' | null;

export type File = {
    file_type: FileTypeInDBBase;
    filesize: number;
    b2_checksum: string;
    modify_date: Date;
    file: string | null;
    file_metadata: ImageMetadata | AudioMetadata | VideoMetadata | null;
    asset: AssetInDB;
    comment: string | null;
};

export type FileInDB = {
    file_type: FileTypeInDBBase;
    filesize: number;
    b2_checksum: string;
    modify_date: Date;
    file: string | null;
    id: number;
};

export type FileTypeInDBBase = {
    mime_type: string;
    id: number;
};

export type HTTPValidationError = {
    detail?: Array<ValidationError>;
};

export type ImageMetadata = {
    type?: 'image';
    width: number;
    height: number;
};

export type type2 = 'image';

export type List_AssetInDB_ = {
    total: number;
    elements: Array<AssetInDB>;
};

export type List_Category_ = {
    total: number;
    elements: Array<Category>;
};

export type List_FileInDB_ = {
    total: number;
    elements: Array<FileInDB>;
};

export type List_Object_ = {
    total: number;
    elements: Array<Object>;
};

export type List_User_ = {
    total: number;
    elements: Array<User>;
};

/**
 * complex type to model multilanguage text
 */
export type MultiLanguage = {
    en?: string | null;
    de?: string | null;
    abbr?: string | null;
    lat?: string | null;
};

export type Object = {
    excavation_id: number;
    excavation_suffix: number;
    local_id: number;
    sub_id: number;
    categories: Array<CategoryInDBBase>;
    feature: number;
    feature_layer: number;
    excavation_step: number;
    position: Coordinates | null;
    feature_date: Date | null;
    name: MultiLanguage;
    comment: string | null;
    id: number;
};

export type ObjectInDB = {
    excavation_id: number;
    excavation_suffix: number;
    local_id: number;
    sub_id: number;
    categories: Array<CategoryInDBBase>;
    feature: number;
    feature_layer: number;
    excavation_step: number;
    position: Coordinates | null;
    feature_date: Date | null;
    name: MultiLanguage;
    comment: string | null;
    id: number;
};

export type Status = {
    status: 'success' | 'failure';
    detail?: string | null;
};

export type status = 'success' | 'failure';

export type Token = {
    access_token: string;
    token_type: 'bearer';
    user_type: 'admin' | 'user';
    name: string | null;
};

export type token_type = 'bearer';

export type user_type = 'admin' | 'user';

export type User = {
    username: string;
    name: string | null;
    email?: string | null;
    is_active?: boolean | null;
    is_admin?: boolean | null;
    id?: number | null;
};

export type UserCreate = {
    username: string;
    name?: string | null;
    email?: string | null;
    is_active?: boolean | null;
    is_admin?: boolean | null;
    password: string;
};

export type UserUpdate = {
    username: string;
    name: string | null;
    email?: string | null;
    is_active?: boolean | null;
    is_admin?: boolean | null;
    password?: string | null;
};

export type ValidationError = {
    loc: Array<(string | number)>;
    msg: string;
    type: string;
};

export type VideoMetadata = {
    type?: 'video';
    duration: number;
    width: number;
    height: number;
};

export type type3 = 'video';

export type GetUserApiV1AdminUserIdGetData = {
    path: {
        /**
         * user id
         */
        id: number;
    };
};

export type GetUserApiV1AdminUserIdGetResponse = User;

export type GetUserApiV1AdminUserIdGetError = HTTPValidationError;

export type UpdateUserApiV1AdminUserIdPatchData = {
    body: UserUpdate;
    path: {
        /**
         * user id
         */
        id: number;
    };
};

export type UpdateUserApiV1AdminUserIdPatchResponse = User;

export type UpdateUserApiV1AdminUserIdPatchError = HTTPValidationError;

export type DeleteUserApiV1AdminUserIdDeleteData = {
    path: {
        /**
         * user id
         */
        id: number;
    };
};

export type DeleteUserApiV1AdminUserIdDeleteResponse = void;

export type DeleteUserApiV1AdminUserIdDeleteError = HTTPValidationError;

export type GetUsersApiV1AdminUserGetData = {
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetUsersApiV1AdminUserGetResponse = List_User_;

export type GetUsersApiV1AdminUserGetError = HTTPValidationError;

export type CreateUserApiV1AdminUserPostData = {
    body: UserCreate;
};

export type CreateUserApiV1AdminUserPostResponse = User;

export type CreateUserApiV1AdminUserPostError = HTTPValidationError;

export type ClearCacheApiV1AdminCacheClearPostResponse = Status;

export type ClearCacheApiV1AdminCacheClearPostError = unknown;

export type LoginAccessTokenApiV1LoginTokenPostData = {
    body: Body_login_access_token_api_v1_login_token_post;
};

export type LoginAccessTokenApiV1LoginTokenPostResponse = Token;

export type LoginAccessTokenApiV1LoginTokenPostError = HTTPValidationError;

export type GetUserSelfApiV1LoginSelfGetResponse = User;

export type GetUserSelfApiV1LoginSelfGetError = unknown;

export type UpdateUserSelfApiV1LoginSelfPatchData = {
    body?: Body_update_user_self_api_v1_login_self_patch;
};

export type UpdateUserSelfApiV1LoginSelfPatchResponse = User;

export type UpdateUserSelfApiV1LoginSelfPatchError = HTTPValidationError;

export type GetAssetsApiV1AssetGetData = {
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetAssetsApiV1AssetGetResponse = List_AssetInDB_;

export type GetAssetsApiV1AssetGetError = HTTPValidationError;

export type GetAssetApiV1AssetAssetGetData = {
    path: {
        /**
         * asset id
         */
        asset: number;
    };
};

export type GetAssetApiV1AssetAssetGetResponse = Asset;

export type GetAssetApiV1AssetAssetGetError = HTTPValidationError;

export type GetAssetFilesApiV1AssetAssetFilesGetData = {
    path: {
        /**
         * asset id
         */
        asset: number;
    };
};

export type GetAssetFilesApiV1AssetAssetFilesGetResponse = List_FileInDB_;

export type GetAssetFilesApiV1AssetAssetFilesGetError = HTTPValidationError;

export type GetCategoriesApiV1CategoriesGetData = {
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * order by field
         */
        o?: FieldTypes;
        /**
         * reverse sorting order
         */
        reverse?: boolean | null;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetCategoriesApiV1CategoriesGetResponse = List_Category_;

export type GetCategoriesApiV1CategoriesGetError = HTTPValidationError;

export type GetCategoryObjectsApiV1CategoriesCatGetData = {
    path: {
        /**
         * category id
         */
        cat: number;
    };
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * order by field
         */
        o?: FieldTypes;
        /**
         * reverse sorting order
         */
        reverse?: boolean | null;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetCategoryObjectsApiV1CategoriesCatGetResponse = List_Object_;

export type GetCategoryObjectsApiV1CategoriesCatGetError = HTTPValidationError;

export type FilterCategoryObjectsApiV1CategoriesCatFilterGetData = {
    path: {
        /**
         * category id
         */
        cat: number;
    };
    query?: {
        /**
         * field the search term is applicaple to
         */
        filter?: FieldTypes;
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * order by field
         */
        o?: FieldTypes;
        /**
         * search term
         */
        q?: string | null;
        /**
         * reverse sorting order
         */
        reverse?: boolean | null;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type FilterCategoryObjectsApiV1CategoriesCatFilterGetResponse = List_Object_;

export type FilterCategoryObjectsApiV1CategoriesCatFilterGetError = HTTPValidationError;

export type GetFilesApiV1FileGetData = {
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetFilesApiV1FileGetResponse = List_FileInDB_;

export type GetFilesApiV1FileGetError = HTTPValidationError;

export type GetFileApiV1FileFileGetData = {
    path: {
        /**
         * file id
         */
        file: number;
    };
};

export type GetFileApiV1FileFileGetResponse = File;

export type GetFileApiV1FileFileGetError = HTTPValidationError;

export type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetData = {
    path: {
        /**
         * file id
         */
        file: number;
        image_format: string;
        quality: string;
        region: string;
        rotation: string;
        size: string;
    };
};

export type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetResponse = unknown;

export type GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetError = HTTPValidationError;

export type GetObjectsApiV1ObjectGetData = {
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * order by field
         */
        o?: FieldTypes;
        /**
         * reverse sorting order
         */
        reverse?: boolean | null;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetObjectsApiV1ObjectGetResponse = List_Object_;

export type GetObjectsApiV1ObjectGetError = HTTPValidationError;

export type GetObjectApiV1ObjectObjGetData = {
    path: {
        /**
         * object handle
         */
        obj: string;
    };
};

export type GetObjectApiV1ObjectObjGetResponse = Object;

export type GetObjectApiV1ObjectObjGetError = HTTPValidationError;

export type GetObjectAssetsApiV1ObjectObjAssetsGetData = {
    path: {
        /**
         * object handle
         */
        obj: string;
    };
    query?: {
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type GetObjectAssetsApiV1ObjectObjAssetsGetResponse = List_AssetInDB_;

export type GetObjectAssetsApiV1ObjectObjAssetsGetError = HTTPValidationError;

export type FilterObjectApiV1ObjectFilterGetData = {
    query?: {
        /**
         * field the search term is applicaple to
         */
        filter?: FieldTypes;
        /**
         * limit output to a number of items
         */
        limit?: number;
        /**
         * order by field
         */
        o?: FieldTypes;
        /**
         * search term
         */
        q?: string | null;
        /**
         * reverse sorting order
         */
        reverse?: boolean | null;
        /**
         * skip number of items
         */
        skip?: number;
    };
};

export type FilterObjectApiV1ObjectFilterGetResponse = List_Object_;

export type FilterObjectApiV1ObjectFilterGetError = HTTPValidationError;

export type $OpenApiTs = {
    '/api/v1/admin/user/{id}': {
        get: {
            req: GetUserApiV1AdminUserIdGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': User;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
        patch: {
            req: UpdateUserApiV1AdminUserIdPatchData;
            res: {
                /**
                 * Successful Response
                 */
                '200': User;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
        delete: {
            req: DeleteUserApiV1AdminUserIdDeleteData;
            res: {
                /**
                 * Successful Response
                 */
                '204': void;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/admin/user/': {
        get: {
            req: GetUsersApiV1AdminUserGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_User_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
        post: {
            req: CreateUserApiV1AdminUserPostData;
            res: {
                /**
                 * Successful Response
                 */
                '200': User;
                /**
                 * Created
                 */
                '201': User;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/admin/cache/clear': {
        post: {
            res: {
                /**
                 * Successful Response
                 */
                '200': Status;
            };
        };
    };
    '/api/v1/login/token': {
        post: {
            req: LoginAccessTokenApiV1LoginTokenPostData;
            res: {
                /**
                 * Successful Response
                 */
                '200': Token;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/login/self': {
        get: {
            res: {
                /**
                 * Successful Response
                 */
                '200': User;
            };
        };
        patch: {
            req: UpdateUserSelfApiV1LoginSelfPatchData;
            res: {
                /**
                 * Successful Response
                 */
                '200': User;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/asset/': {
        get: {
            req: GetAssetsApiV1AssetGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_AssetInDB_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/asset/{asset}': {
        get: {
            req: GetAssetApiV1AssetAssetGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': Asset;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/asset/{asset}/files': {
        get: {
            req: GetAssetFilesApiV1AssetAssetFilesGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_FileInDB_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/categories/': {
        get: {
            req: GetCategoriesApiV1CategoriesGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_Category_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/categories/{cat}/': {
        get: {
            req: GetCategoryObjectsApiV1CategoriesCatGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_Object_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/categories/{cat}/filter/': {
        get: {
            req: FilterCategoryObjectsApiV1CategoriesCatFilterGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_Object_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/file/': {
        get: {
            req: GetFilesApiV1FileGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_FileInDB_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/file/{file}': {
        get: {
            req: GetFileApiV1FileFileGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': File;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/image/{file}/{region}/{size}/{rotation}/{quality}.{image_format}': {
        get: {
            req: GetImageApiV1ImageFileRegionSizeRotationQualityImageFormatGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': unknown;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/object/': {
        get: {
            req: GetObjectsApiV1ObjectGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_Object_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/object/{obj}': {
        get: {
            req: GetObjectApiV1ObjectObjGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': Object;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/object/{obj}/assets': {
        get: {
            req: GetObjectAssetsApiV1ObjectObjAssetsGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_AssetInDB_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
    '/api/v1/object/filter/': {
        get: {
            req: FilterObjectApiV1ObjectFilterGetData;
            res: {
                /**
                 * Successful Response
                 */
                '200': List_Object_;
                /**
                 * Validation Error
                 */
                '422': HTTPValidationError;
            };
        };
    };
};

export type GetAssetsApiV1AssetGetResponseTransformer = (data: any) => Promise<GetAssetsApiV1AssetGetResponse>;

export type List_AssetInDB_ModelResponseTransformer = (data: any) => List_AssetInDB_;

export type AssetInDBModelResponseTransformer = (data: any) => AssetInDB;

export const AssetInDBModelResponseTransformer: AssetInDBModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const List_AssetInDB_ModelResponseTransformer: List_AssetInDB_ModelResponseTransformer = data => {
    if (Array.isArray(data?.elements)) {
        data.elements.forEach(AssetInDBModelResponseTransformer);
    }
    return data;
};

export const GetAssetsApiV1AssetGetResponseTransformer: GetAssetsApiV1AssetGetResponseTransformer = async (data) => {
    List_AssetInDB_ModelResponseTransformer(data);
    return data;
};

export type GetAssetApiV1AssetAssetGetResponseTransformer = (data: any) => Promise<GetAssetApiV1AssetAssetGetResponse>;

export type AssetModelResponseTransformer = (data: any) => Asset;

export const AssetModelResponseTransformer: AssetModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    if (Array.isArray(data?.children)) {
        data.children.forEach(AssetInDBModelResponseTransformer);
    }
    return data;
};

export const GetAssetApiV1AssetAssetGetResponseTransformer: GetAssetApiV1AssetAssetGetResponseTransformer = async (data) => {
    AssetModelResponseTransformer(data);
    return data;
};

export type GetAssetFilesApiV1AssetAssetFilesGetResponseTransformer = (data: any) => Promise<GetAssetFilesApiV1AssetAssetFilesGetResponse>;

export type List_FileInDB_ModelResponseTransformer = (data: any) => List_FileInDB_;

export type FileInDBModelResponseTransformer = (data: any) => FileInDB;

export const FileInDBModelResponseTransformer: FileInDBModelResponseTransformer = data => {
    if (data?.modify_date) {
        data.modify_date = new Date(data.modify_date);
    }
    return data;
};

export const List_FileInDB_ModelResponseTransformer: List_FileInDB_ModelResponseTransformer = data => {
    if (Array.isArray(data?.elements)) {
        data.elements.forEach(FileInDBModelResponseTransformer);
    }
    return data;
};

export const GetAssetFilesApiV1AssetAssetFilesGetResponseTransformer: GetAssetFilesApiV1AssetAssetFilesGetResponseTransformer = async (data) => {
    List_FileInDB_ModelResponseTransformer(data);
    return data;
};

export type GetFilesApiV1FileGetResponseTransformer = (data: any) => Promise<GetFilesApiV1FileGetResponse>;

export const GetFilesApiV1FileGetResponseTransformer: GetFilesApiV1FileGetResponseTransformer = async (data) => {
    List_FileInDB_ModelResponseTransformer(data);
    return data;
};

export type GetFileApiV1FileFileGetResponseTransformer = (data: any) => Promise<GetFileApiV1FileFileGetResponse>;

export type FileModelResponseTransformer = (data: any) => File;

export const FileModelResponseTransformer: FileModelResponseTransformer = data => {
    if (data?.modify_date) {
        data.modify_date = new Date(data.modify_date);
    }
    if (data?.asset) {
        AssetInDBModelResponseTransformer(data.asset);
    }
    return data;
};

export const GetFileApiV1FileFileGetResponseTransformer: GetFileApiV1FileFileGetResponseTransformer = async (data) => {
    FileModelResponseTransformer(data);
    return data;
};

export type GetObjectAssetsApiV1ObjectObjAssetsGetResponseTransformer = (data: any) => Promise<GetObjectAssetsApiV1ObjectObjAssetsGetResponse>;

export const GetObjectAssetsApiV1ObjectObjAssetsGetResponseTransformer: GetObjectAssetsApiV1ObjectObjAssetsGetResponseTransformer = async (data) => {
    List_AssetInDB_ModelResponseTransformer(data);
    return data;
};